import { render, staticRenderFns } from "./DonationsLog.vue?vue&type=template&id=b452c706&"
import script from "./DonationsLog.vue?vue&type=script&lang=js&"
export * from "./DonationsLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports